import { DATA_BORDER_DOUBLEBOTTOMLINE } from '../report/rowTypes';

const leaveTotalRowOnTop = (valueA, valueB, isInverted) => {
  if (valueA.type === DATA_BORDER_DOUBLEBOTTOMLINE) {
    return isInverted ? 1 : -1;
  }
  if (valueB.type === DATA_BORDER_DOUBLEBOTTOMLINE) {
    return isInverted ? -1 : 1;
  }
  return null;
};

export const valueDataGetter = key => ({ data }) => ({
  data: data[key],
  key,
  type: data.type,
});

export const totalRowCellStringComparator = (valueA, valueB, nodeA, nodeB, isInverted) =>
  leaveTotalRowOnTop(valueA, valueB, isInverted) || (valueA.data || '').localeCompare(valueB.data);

export const totalRowCellNumberComparator = (valueA, valueB, nodeA, nodeB, isInverted) =>
  leaveTotalRowOnTop(valueA, valueB, isInverted) || (valueA.data || 0) - (valueB.data || 0);

export const toString = data => {
  if (data === null) {
    return '';
  }

  if (typeof data === 'boolean' || typeof data === 'number') {
    return data.toString();
  }

  if (typeof data === 'string') {
    return data;
  }

  if (typeof data === 'symbol') {
    throw new TypeError();
  }

  return JSON.stringify(data);
};

export const equalNodes = (node, selectionState) =>
  selectionState.fields.every(field => node.data[field] === selectionState.values[field]);

const compareCollator = new Intl.Collator('en', {
  sensitivity: 'accent',
});

export const comparator = (valueA, valueB) => {
  if (typeof valueA === 'undefined' && typeof valueB === 'undefined') {
    return 0;
  }

  if (typeof valueA === 'undefined') {
    return 1;
  }

  if (typeof valueB === 'undefined') {
    return -1;
  }

  if (typeof valueA === 'number' && typeof valueB === 'number') {
    return valueA - valueB;
  }

  const aString = toString(valueA);
  const bString = toString(valueB);

  return compareCollator.compare(aString, bString);
};
